import "./ContactsScreen2.css";
import globalStates from '../../utils/global';
import { useContext, useEffect, useMemo, useState } from "react";
import { iconCompany } from "../../assets";
import { MapComponent2 } from "../../components";

const ContactsScreen2 = () =>{
    const context = globalStates && globalStates.globalContext;
    const globalContext:any = useContext(context);
    const windowWidthClass = globalContext && globalContext.windowWidthClass;
    const defaultLanguage = globalContext && globalContext.defaultLanguage;

    const companyProfileEn = useMemo(()=>{
        return {
            title1: "PT. Sinar Surya Fortuna",
            desc1: [
                "PT Sinar Surya Fortuna, under the Naturalhoodspices brand, is an Indonesian trading and export company specializing in premium spices. Established in 2023 and headquartered in Jakarta, we are dedicated to introducing the rich heritage of Indonesian spices to the global market",
                "Through a trusted network of local collectors and farmers, we ensure consistent supply andquality. Every product is handled with strict quality control, safe packaging, and reliable exportdocumentation. We also provide private label solutions, customized packaging, and support mixed container shipments to meet diverse client needs."
            ],

            titleVision: "Vision",
            descVision: [
                "Our vision is to become a leading Indonesian spice exporter, recognized worldwide for quality, trust, and professionalism. We aim to introduce and promote the rich heritage of Indonesian spices across the globe, enhancing appreciation for Indonesia’s natural wealth and culture.",
                  ], 
            titleMission: "Mission",
            descMission:[
                "1. Ensure client satisfaction through high-quality products and reliable services.",
                "2. Support local communities and spice collectors by connecting them to international markets.",
                "3. Contribute to Indonesia’s “Spices Up the World” initiative through consistent dedication and innovation."
            ],
                
            title3: "Address",
            desc3: "WTC Mangga dua LG Floor Blok C No.53, Pademangan, North Jakarta 14420",

           
        }
    }, []);

    
    const companyProfileIna = useMemo(()=>{
        return{
            title1: "PT. Sinar Surya Fortuna",
            desc1: [
    "PT Sinar Surya Fortuna, di bawah merek Naturalhoodspices, adalah perusahaan perdagangan dan ekspor asal Indonesia yang mengkhususkan diri pada rempah-rempah premium. Didirikan pada tahun 2023 dan berkantor pusat di Jakarta, kami berdedikasi untuk memperkenalkan warisan kaya rempah-rempah Indonesia ke pasar global.",
    "Melalui jaringan terpercaya pengumpul dan petani lokal, kami memastikan pasokan dan kualitas yang konsisten. Setiap produk ditangani dengan kontrol kualitas ketat, kemasan aman, dan dokumentasi ekspor yang andal. Kami juga menyediakan solusi private label, kemasan yang disesuaikan, serta mendukung pengiriman kontainer campuran untuk memenuhi berbagai kebutuhan klien."
],
            titleVision: "Visi",
            descVision: [
    "Visi kami adalah menjadi eksportir rempah-rempah Indonesia terkemuka, yang diakui secara global untuk kualitas, kepercayaan, dan profesionalisme. Kami bertujuan untuk memperkenalkan dan mempromosikan warisan kaya rempah-rempah Indonesia ke seluruh dunia, meningkatkan apresiasi terhadap kekayaan alam dan budaya Indonesia."
],
            titleMission: "Misi",
            descMission: [
    "1. Menjamin kepuasan klien melalui produk berkualitas tinggi dan layanan yang dapat diandalkan.",
    "2. Mendukung komunitas lokal dan pengumpul rempah dengan menghubungkan mereka ke pasar internasional.",
    "3. Berkontribusi pada inisiatif Indonesia “Spices Up the World” melalui dedikasi dan inovasi yang konsisten."
],
                 title3: "Alamat",
            desc3: "WTC Mangga dua LG Floor Blok C No.53, Pademangan, North Jakarta 14420"
        }
    }, []);
    //     const companyProfileEn = useMemo(()=>{
    //     return {
    //         title1: "PT. Sinar Surya Fortuna",
    //         desc1: "Company which engage in trading export/import for spices. Indonesia is one of thropical countries that have so many natural resources and spices are one of them. We are one of trading companies with having well resources and networks for provides high quality products for our domestic and international clients. This is our dedication as PT Sinar Surya Fortuna for Indonesia peoples nor International to achieve clients satisfaction also trust for growing local economic and reintroduce spices from Indonesia in line with government call ” Spices up the World “.",
    //         title2: "Vision and Mission",
    //         desc2: "Company which engage in trading export/import for spices. Indonesia is one of thropical countries that have so many natural resources and spices are one of them. We are one of trading companies with having well resources and networks for provides high quality products for our domestic and international clients. This is our dedication as PT Sinar Surya Fortuna for Indonesia peoples nor International to achieve clients satisfaction also trust for growing local economic and reintroduce spices from Indonesia in line with government call ” Spices up the World “.",
    //         title3: "Address",
    //         desc3: "WTC Mangga dua LG Floor Blok C No.53, Pademangan, North Jakarta 14420"
    //     }
    // }, []);

    
    // const companyProfileIna = useMemo(()=>{
    //     return{
    //         title1: "PT. Sinar Surya Fortuna",
    //         desc1: "Perusahaan yang bergerak di bidang ekspor/impor rempah-rempah. Indonesia adalah salah satu negara tropis yang memiliki banyak sumber daya alam, termasuk rempah-rempah. Kami adalah salah satu perusahaan perdagangan yang memiliki sumber daya dan jaringan yang baik untuk menyediakan produk berkualitas tinggi bagi klien domestik dan internasional. Dedikasi kami sebagai PT Sinar Surya Fortuna adalah untuk masyarakat Indonesia dan internasional untuk mencapai kepuasan dan kepercayaan klien, serta untuk mendukung pertumbuhan ekonomi lokal dan memperkenalkan kembali rempah-rempah dari Indonesia sesuai dengan panggilan pemerintah 'Spices up the World.'",
    //         title2: "Visi dan Misi",
    //         desc2: "Perusahaan yang bergerak di bidang ekspor/impor rempah-rempah. Indonesia adalah salah satu negara tropis yang memiliki banyak sumber daya alam, termasuk rempah-rempah. Kami adalah salah satu perusahaan perdagangan yang memiliki sumber daya dan jaringan yang baik untuk menyediakan produk berkualitas tinggi bagi klien domestik dan internasional. Dedikasi kami sebagai PT Sinar Surya Fortuna adalah untuk masyarakat Indonesia dan internasional untuk mencapai kepuasan dan kepercayaan klien, serta untuk mendukung pertumbuhan ekonomi lokal dan memperkenalkan kembali rempah-rempah dari Indonesia sesuai dengan panggilan pemerintah 'Spices up the World.'",
    //         title3: "Alamat",
    //         desc3: "WTC Mangga dua LG Floor Blok C No.53, Pademangan, North Jakarta 14420"
    //     }
    // }, []);


    const [companyProfile, setCompanyProfile] = useState(companyProfileEn as any);
    useEffect(()=>{
        if(defaultLanguage==="en"){
            setCompanyProfile(companyProfileEn)
        } else {
            setCompanyProfile(companyProfileIna)
        }
    }, [defaultLanguage, companyProfileEn, companyProfileIna]);

 
    const {title1, desc1, titleVision, titleMission, descVision, descMission, title3, desc3} = companyProfile;
    return(
        <div className={`${windowWidthClass}-contacts-screen-2`}>
            <div className="screen-wrapper">
                <img src={iconCompany} alt="company logo"/>
                <h2>{title1}</h2>
                <p>{desc1[0]}</p>
                <p>{desc1[1]}</p>

                <h2>{titleVision}</h2>
                <p>{descVision[0]}</p>
                <h2>{titleMission}</h2>
                <div className="bullets">
                <p>{descMission[0]}</p>
                <p>{descMission[1]}</p>
                <p>{descMission[2]}</p>
                </div>

                <h2>{title3}</h2>
                <p>{desc3}</p>

                <MapComponent2/>
            </div>
            
        </div>
    )
};

export default ContactsScreen2;